module.exports = __webpack_public_path__ + "static/comity-e832533d6dc4c9059a01bd29837139f4.png";